<template>
    <el-button
    type="primary"
    size="mini"
    icon="el-icon-download"
    @click="handleCsvDownload"
    style="margin-right: 10px;"
    :loading="downloadingCsv">
    {{$t('common.csv')}}
    </el-button>
</template>
<script>
export default {
  name: 'DownloadCsv',
  props: {
    dispatchAction: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      default: 'report.csv'
    },
    fileType: {
      type: String,
      default: 'text/csv'
    },
    downloadFunction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      downloadingCsv: false,
    };
  },
  methods: {
    handleCsvDownload() {
      this.downloadingCsv = true;
      if (this.downloadFunction) {
        this.downloadFunction();
        this.downloadingCsv = false;
      } else {
        this.$store.dispatch(this.dispatchAction)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: this.fileType }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.downloadingCsv = false;
          })
          .catch(() => {
            this.downloadingCsv = false;
          });
      }
    }
  },
};
</script>
